import { FC, useState } from 'react';
import { Banner } from 'ui/banner';
import { BannerProps } from 'ui/banner/types';

export type DismissBannerProps = {
  BannerComponent?: FC<React.PropsWithChildren<unknown>>;
} & BannerProps;
export const DismissBanner: FC<React.PropsWithChildren<DismissBannerProps>> = ({
  children,
  BannerComponent = Banner,
  ...bannerProps
}) => {
  const [displayBanner, updateBannerDisplay] = useState(true);
  const maybeBanner = displayBanner ? (
    <BannerComponent onClose={() => updateBannerDisplay(false)} {...bannerProps}>
      {children}
    </BannerComponent>
  ) : null;
  return <>{maybeBanner}</>;
};
